// CrossEntityTabs — MD3 Tabs для переключения между cross-entity представлениями
// (например: сделки / контакты / компании на странице детали компании).
import { Tabs, Tab, Box } from '@mui/material';
import { useState, type SyntheticEvent } from 'react';

export interface CrossEntityTab {
  /** Уникальный id вкладки. */
  id: string;
  /** Подпись на вкладке. */
  label: string;
}

interface CrossEntityTabsProps {
  /** Список вкладок. */
  tabs: CrossEntityTab[];
  /** id активной вкладки (controlled). */
  activeId: string;
  /** Колбэк при смене вкладки. */
  onChange: (id: string) => void;
}

/** MD3 Tabs для cross-entity представлений. */
export function CrossEntityTabs({ tabs, activeId, onChange }: CrossEntityTabsProps): JSX.Element {
  const activeIndex = Math.max(0, tabs.findIndex((t) => t.id === activeId));

  function handleChange(_event: SyntheticEvent, index: number): void {
    const tab = tabs[index];
    if (tab) onChange(tab.id);
  }

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
      <Tabs value={activeIndex} onChange={handleChange} variant="scrollable" scrollButtons="auto">
        {tabs.map((tab) => (
          <Tab key={tab.id} label={tab.label} data-testid={`crm-tab-${tab.id}`} />
        ))}
      </Tabs>
    </Box>
  );
}
